import http from "./axios/http";

export function getCommonConfig() {
  return http.get('/config/common_config?t=' + new Date().getTime())
}


